import React from "react";
import { useI18n } from "@/i18n/I18nContext";

const LegalPageShell = ({ dictionaryKey, testid, sectionKeys }) => {
  const { t } = useI18n();
  return (
    <section className="bg-white" data-testid={testid}>
      <div className="mx-auto max-w-3xl px-5 py-16 lg:px-8 lg:py-24">
        <p className="text-xs uppercase tracking-widest text-[#0D7A5F]">
          {t(`${dictionaryKey}.lastUpdated`)}
        </p>
        <h1 className="mt-3 font-serif text-3xl font-bold text-[#0F2C59] sm:text-4xl lg:text-5xl">
          {t(`${dictionaryKey}.title`)}
        </h1>
        <p className="mt-5 text-base leading-relaxed text-[#475569]">
          {t(`${dictionaryKey}.intro`)}
        </p>
        <div className="mt-10 space-y-8">
          {sectionKeys.map((key) => (
            <div key={key}>
              <h2 className="font-serif text-xl font-semibold text-[#0F2C59] sm:text-2xl">
                {t(`${dictionaryKey}.sections.${key}.title`)}
              </h2>
              <p className="mt-3 text-base leading-relaxed text-[#475569]">
                {t(`${dictionaryKey}.sections.${key}.text`)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LegalPageShell;
